import { COLORS } from "assets/styles/colors";
import styled from "styled-components/macro";

export const Container = styled.div`
  .p-datatable-tbody {
    white-space: nowrap !important ;
    & > tr:nth-child(odd) {
      background-color: ${COLORS.white};
    }

    & > tr:nth-child(even) {
      background-color: ${COLORS.grey};
    }
  }

  .column {
    font-size: 10px;
    font-family: Montserrat;
    padding: 2px !important;

    div {
      justify-content: center;
    }
  }
  .checked-row > td {
    background-color: ${COLORS.grey} !important;
  }

  .selected > td {
    background-color: ${COLORS.light_green} !important;
  }

  .archived > td {
    background-color: rgba(129, 129, 129, 0.3) !important;
  }

  .column-header {
    font-size: 10px;
    height: 40px;
    div {
      display: flex;
      justify-content: center;
    }
  }

  .column-body {
    font-size: 14px;
    text-align: center !important;
    padding: 10px 10px !important;

    & > div,
    & > svg {
      display: flex;
      justify-content: center;
      width: 100% !important;
    }
  }
`;
